import { createContext, useContext, useMemo } from 'react';

const TopicsIndexContext = createContext();

const TopicsIndexProvider = ({ children, ...propsWithoutChildren }) => {
  const value = useMemo(() => propsWithoutChildren, [propsWithoutChildren]);

  return (
    <TopicsIndexContext.Provider value={value}>
      {children}
    </TopicsIndexContext.Provider>
  );
};

export const useTopicsIndexContext = () => {
  const context = useContext(TopicsIndexContext);

  if (!context) {
    throw new Error(
      'useTopicsIndexContext must be used within a TopicsIndexProvider',
    );
  }

  return context;
};

export default TopicsIndexProvider;
